module.exports = __webpack_public_path__ + "employees-21b62107/icon-fencing-32be84af829bbb24c95a1d2a25dffd37.png";